import React from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Stage } from '@react-three/drei';
import Model from './Model';
import { useParams } from 'react-router-dom';
import { encyptedData, decryptedData } from './Access';
import NotFound from './NotFound';

const Home = () => {
    const {viewerId} = useParams();
    let viewerIdURL = viewerId.replaceAll("~","/");
    viewerIdURL = decryptedData(viewerIdURL);
    // console.log(viewerIdURL,"viewerId");
    
    return (
      <>
    {viewerIdURL ?
      <>
    <Canvas camera={{ position: [5, 5, 5], fov: 50 }}>
      <ambientLight intensity={0.5} />
      <Stage environment="city" intensity={0.6}>
        <Model 
        viewerIdURL={viewerIdURL}
        />
      </Stage>
      <OrbitControls enableZoom={true} />
    </Canvas>
    </>
    : (
      <NotFound />
    )
    }
    </>
    );

};

export default Home;